<div fxLayout="column" class="select-object-type-container" #boundaryContainer>
  <div class="load-indicator-container" *ngIf="loading">
    <p>{{ translation?.loadingMessage }}</p>
    <abc-load-indicator></abc-load-indicator>
  </div>
  <div *ngIf="!loading" class="object-type-container">
    <opath-core-nav-header
      [title]="translation?.title"
      (onFilterOptionChanged)="filterOptionChanged($event)"
      (onSearchTermChanged)="searchTermChanged($event)"
    ></opath-core-nav-header>

    <div
      cdkDropList
      id="objectTypes"
      cdkDropListConnectedTo="queriesTree"
      [cdkDropListData]="objectTypeInfosBackup"
      cdkDropListLockAxis="x"
      class="object-type-list"
      [cdkDropListDisabled]="false"
    >
      <p>{{ translation?.description }}</p>

      <abc-list
        [dataSource]="objectTypeInfosBackup"
        class="object-type-item"
        searchExpr="Name"
        [pageLoadMode]="'scrollBottom'"
        [searchValue]="searchTerm"
        [searchMode]="currentFilterOption?.searchMode ?? 'contains'"
      >
        <div *dxTemplate="let objectTypeInfo of 'item'" cdkDrag>
          <abc-button
            cdkDrag
            [text]="objectTypeInfo.DisplayText"
            [icon]="ColumnTypeIcon.reference"
            [width]="'100%'"
            [data-objectTypeInfo]="objectTypeInfo"
          ></abc-button>
        </div>
      </abc-list>
    </div>
  </div>
</div>
